import * as Sentry from "@sentry/react"
import { AlertOctagonIcon, RefreshCw } from "lucide-react"
import { useEffect } from "react"
import { useRouteError } from "react-router-dom"
import darkLogo from "@/assets/images/firme-dark.png"
import whiteLogo from "@/assets/images/firme-white.png"
import { ThemePicker } from "@/components/theme-picker"
import { Button } from "@/components/ui/button"
import { useTheme } from "@/components/use-theme"

const ErrorPage = () => {
  const { theme } = useTheme()
  const error = useRouteError()

  // Always report errors to Sentry when root error page is shown
  useEffect(() => {
    if (error) {
      Sentry.captureException(error, {
        tags: {
          errorBoundary: "RootLayout",
          errorType:
            error instanceof Error ? error.constructor.name : "UnknownError",
          page: "ErrorPage",
        },
        extra: {
          errorName: error instanceof Error ? error.name : "Unknown",
          errorMessage: error instanceof Error ? error.message : String(error),
          errorStack: error instanceof Error ? error.stack : undefined,
          url: window.location.href,
          userAgent: navigator.userAgent,
          timestamp: new Date().toISOString(),
          theme: theme,
        },
        level: "error",
      })
    }
  }, [error, theme])

  return (
    <div className="flex h-screen flex-col items-stretch">
      <header className="border-b text-center">
        <div className="container flex flex-row items-center justify-between py-4">
          <img
            src={theme === "dark" ? whiteLogo : darkLogo}
            alt="Firme"
            width="120px"
          />
          <div>
            <ThemePicker />
          </div>
        </div>
      </header>

      <div className="flex h-screen grow flex-col items-center justify-center gap-10">
        <AlertOctagonIcon
          height="200px"
          width="100%"
          className="text-red-500"
        />

        <h1 className="text-4xl">Ha ocurrido un error inesperado</h1>

        <div>
          <Button size="lg" onClick={() => window.location.reload()}>
            <RefreshCw className="mr-3" />
            <span>Recargar</span>
          </Button>
        </div>
      </div>

      <footer className="py-6"></footer>
    </div>
  )
}

export { ErrorPage }
